import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaConfiguracionRegistrosPatronalesComponent {
  empresaId
  registroPatronalId
  onClose
  registrosPatronales

  constructor (EmpresaConfiguracionRegistroPatronalHistorial) {
    this.EmpresaConfiguracionRegistroPatronalHistorial = EmpresaConfiguracionRegistroPatronalHistorial
  }

  guardar() {

    if(this.procesando) return

    this.procesando = true
    this.error = null

    this.EmpresaConfiguracionRegistroPatronalHistorial.post(this.empresaId, this.registroPatronalId, this.data)
      .then(() => (this.procesado = true))
      .catch((error) => (this.error = error?.data ?? error))
      .finally(() => (this.procesando = false))
  }

  cerrar() {
    this.onClose({$event: {data: this.procesado ? this.data : null}})
  }
}

module.component('empresaConfiguracionRegistroPatronalAgregar', {
  controller: EmpresaConfiguracionRegistrosPatronalesComponent,
  template,
  bindings: {
    empresaId: '<',
    registroPatronalId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/registroPatronal/agregar/component.js